(function ($) {
	$(function () {
		$(".main-discover").on("inview", function () {
			$(".main-discover .ex-countup").each(function (key, value) {
				let $target	=	$(this);

				setTimeout(function () {
					$target.numerator({
						easing		:	"linear",
						duration	:	800,
						toValue		:	$target.attr("data-count"),
						rounding	:	0,
					});
				}, (key * 300));
			});
		});

		//スライド
		$(".mainvisuals").slick({
			autoplay	:	true,
			prevArrow	:	'<div class="mainvisuals-arrow ex-prev"></div>',
			nextArrow	:	'<div class="mainvisuals-arrow ex-next"></div>',
		});

		//ログイン
		$(".main-membership-detail-login").on("submit", function (e) {
			e.preventDefault();

			let $form	=	$(this);
			let url		=	WKTValues.themeURL;

			$form.addClass("ex-loading");
			$form.find(".ex-error").empty();
			$form.find(".ex-message").hide();

			$.ajax({
				url			:	url +"/ajax.php",
				method		:	"post",
				data		:	$form.serialize(),
				dataType	:	"json",
				timeout		:	300 * 1000,
			}).done(function (results) {
				if(results.code == "200") {
					$form.find(".ex-success").fadeIn();

					if(results.data.redirect) {
						location.href	=	WKTValues.homeURL + results.data.redirect;
					}
				}
				else if(results.code == "302") {
					location.href	=	WKCPValues.homeURL +"/login"
				}
				else if(results.code == "419") {
					$form.find(".ex-message.ex-error").text(results.message).stop().fadeIn();
				}
				else {
					for(let key in results.errors) {
						$form.find(".ex-error[data-name="+ Common.escapeSelector(key) +"]").text(results.errors[key]);

						$form.find(".ex-message.ex-error").text("エラーがあります").stop().fadeIn();
					}
					
					if($form.find(".ex-error[data-name]:not(:empty):first").length != 0) {
						$("html, body").animate({scrollTop: $form.find(".ex-error[data-name]:not(:empty):first").closest(".ex-element").position().top});
					}
				}
			}).fail(function (xhr, status, error) {
				$form.find(".ex-error").text("エラーがあります").stop().fadeIn();
			}).always(function () {
				$form.removeClass("ex-loading");
			});
		});

		//グローバルナビ対策
		$(".navi-tab a[href^='/#']").on("click", function (e) {
			$(".header-menu.ex-menu").trigger("click");
		});
	});
})(jQuery);